/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";

export function registerCommands(dc: IEditor): void {
	const viewSvc = dc.get("viewService");
	const commandsSvc = dc.get("commandsService");

	commandsSvc.register({
		id: "documentation.open",
		label: "Open Documentation",
		args: [
			{
				label: "Document path",
				isOptional: true
			},
			{
				label: "Open in new tab",
				isOptional: true
			}
		],
		returns: "none",
		handler: async (args) => {
			const docPath = args?.[0] as string | undefined;
			const openInNewTab = args?.[1] as boolean | undefined;

			// Generate unique ID for new tabs, otherwise reuse existing documentation view
			const viewId = openInNewTab
				? `documentation:${Date.now()}-${Math.random().toString(36).substring(2, 9)}`
				: "documentation";

			viewSvc.open("documentation", viewId, { docPath }, true);
		}
	});
}
